export default __webpack_public_path__ + "static/media/3ab85d97e799db388a98c791288c7b75.c44e9f9f.svg";